import React from 'react';
import Loadable from 'react-loadable';
import { Loader } from '../../../../../components';

const HighchartComponentLazy = Loadable({
  loader: () => import('./index.lazy'),
  loading: () => (<Loader loading inline />),
});

export default HighchartComponentLazy;
